<template>
    <div>
        <fieldset class="mb-3" :disabled="loading">
            <div class="form-check">

                <input type="checkbox" class="form-check-input"
                       v-model="formData.invoice_requested"
                       name="invoice_requested"
                       id="invoice_requested">

                <label class="form-check-label" for="invoice_requested">
                    {{ $t("booking.inputs.hasEuTaxNumAndWantInvoice.label") }}
                </label>

            </div>
        </fieldset>

        <fieldset v-if="formData.invoice_requested" :disabled="loading">

            <div class="mb-3">
                <label for="invoice_eu_tax_number">
                    {{ $t("booking.inputs.invoice.eu_tax_number.label") }}:
                </label>

                <input type="text" class="form-control"
                       name="invoice_eu_tax_number"
                       id="invoice_eu_tax_number"
                       v-model="formData.invoice_eu_tax_number"
                       maxlength="50"
                       :placeholder="$t('booking.inputs.invoice.eu_tax_number.placeholder')"
                       required>
            </div>

            <div class="mb-3">
                <label for="invoice_name">
                    {{ $t("booking.inputs.invoice.name.label") }}:
                </label>

                <input type="text" class="form-control"
                       name="invoice_address"
                       id="invoice_name"
                       v-model="formData.invoice_name"
                       maxlength="255"
                       :placeholder="$t('booking.inputs.invoice.name.placeholder')"
                       required>
            </div>

            <div class="mb-3">
                <label for="invoice_address">
                    {{ $t("booking.inputs.invoice.address.label") }}:
                </label>

                <input type="text" class="form-control"
                       name="invoice_address"
                       id="invoice_address"
                       v-model="formData.invoice_address"
                       maxlength="255"
                       :placeholder="$t('booking.inputs.invoice.address.placeholder')"
                       required>
            </div>

            <div class="mb-3">
                <label for="invoice_town">
                    {{ $t("booking.inputs.invoice.town.label") }}:
                </label>

                <input type="text" class="form-control"
                       name="invoice_town"
                       id="invoice_town"
                       v-model="formData.invoice_town"
                       maxlength="50"
                       :placeholder="$t('booking.inputs.invoice.town.placeholder')"
                       required>
            </div>

            <div class="mb-3">
                <label for="invoice_postcode">
                    {{ $t("booking.inputs.invoice.postcode.label") }}:
                </label>

                <input type="text" class="form-control"
                       name="invoice_postcode"
                       id="invoice_postcode"
                       v-model="formData.invoice_postcode"
                       maxlength="20"
                       :placeholder="$t('booking.inputs.invoice.postcode.placeholder')"
                       required>
            </div>

        </fieldset>
    </div>
</template>

<script>
export default {
    props: {
        loading: {
            required: true,
            type: Boolean,
        },
        formData: {
            required: true,
            type: Object,
        },
    },
}
</script>

<style scoped>

</style>
